import * as React from 'react'

import { IconProps } from '../types'

function DollarCircle(props: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-11C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm1 4.12a3.724 3.724 0 0 1 2.164 1.405C15.78 7.35 16 8.32 16 9h-2c0-.319-.117-.85-.437-1.275-.284-.38-.76-.725-1.636-.725-.98 0-1.406.296-1.607.528-.226.263-.32.625-.32.972 0 .3.063.553.315.841.29.33.874.757 2.056 1.23 1.293.517 2.317 1.078 3.024 1.784.75.75 1.105 1.63 1.105 2.645 0 1.835-1.332 3.514-3.5 3.911V20h-2v-1.108a4.574 4.574 0 0 1-2.319-1.328C7.97 16.814 7.5 15.83 7.5 15h2c0 .17.156.686.631 1.186a2.53 2.53 0 0 0 1.87.814c1.748 0 2.499-1.102 2.499-2 0-.484-.144-.855-.52-1.23-.418-.42-1.143-.858-2.351-1.341-1.317-.527-2.233-1.1-2.819-1.77A3.153 3.153 0 0 1 8 8.5c0-.653.17-1.54.806-2.278.51-.59 1.24-.995 2.194-1.15V4h2v1.12Z"
      />
    </svg>
  )
}
export default DollarCircle
